import React from "react";
import Content from "../content/Content";

export default function Landing() {
  return (
    <div style={{ backgroundColor: "#dae0e6" }}>
      <Content />
    </div>
  );
}
